var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "_900 big"
  }, [_vm._v(" Úprava bonity ")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "kids-form",
      "disabled": _vm.saving
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? "Ukladám..." : "Uložiť") + " ")])]), _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "header-block inline"
  }, [_c('div', [_c('div', {
    staticClass: "bold noselect"
  }, [_vm._v("Žiadateľ")]), _c('div', {
    staticClass: "text-cta justify-content-start",
    on: {
      "click": function click($event) {
        return _vm.editBonitaOf(_vm.applicant, 'Žiadateľ');
      }
    }
  }, [_vm._v("EDIT")])]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]), (_vm.coApplicant ? _vm.coApplicant : null) ? _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', [_c('div', {
    staticClass: "bold noselect"
  }, [_vm._v("Spolužiadateľ")]), _c('div', {
    staticClass: "text-cta justify-content-start",
    on: {
      "click": function click($event) {
        return _vm.editBonitaOf(_vm.coApplicant, 'Spolužiadateľ');
      }
    }
  }, [_vm._v("EDIT")])]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "sub-popup-wrapper"
  }, [_c('client-add-handler', {
    attrs: {
      "rules": ['single'],
      "client-info": {
        type: 'Spolužiadateľ'
      }
    }
  })], 1), _c('div', {
    staticClass: "splitter"
  }, [_vm._v(" Počítame s celkovým počtom detí " + _vm._s(_vm.totalKids) + " ")]), _c('form', {
    attrs: {
      "id": "kids-form"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveKidsForm.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "deti-pocet-z"
    }
  }, [_vm._v("Deti len žiadateľa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kids_applicant_only,
      expression: "form.kids_applicant_only",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "name": "deti-pocet-z",
      "id": "deti-pocet-z",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kids_applicant_only
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kids_applicant_only", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.coApplicant ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "deti-pocet-t"
    }
  }, [_vm._v("Spoločné deti")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kids_shared,
      expression: "form.kids_shared",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "name": "deti-pocet-t",
      "id": "deti-pocet-t",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kids_shared
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kids_shared", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "deti-pocet-s"
    }
  }, [_vm._v("Deti len spolužiadateľa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.kids_coapplicant_only,
      expression: "form.kids_coapplicant_only",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "255",
      "step": "1",
      "name": "deti-pocet-s",
      "id": "deti-pocet-s",
      "required": ""
    },
    domProps: {
      "value": _vm.form.kids_coapplicant_only
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "kids_coapplicant_only", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]) : _vm._e()]), _vm._m(0)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "light"
  }, [_vm._v(" Každé dieťa zadajte iba do jednej skupiny. Zadajte všetky deti do veku 21 rokov vrátane. ")])]);

}]

export { render, staticRenderFns }